import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  FileTextOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { maskMoney } from "../../../helpers/masks";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const TreinamentosCadQuestoes = () => {
  const { id_grupo, id_formulario, id_curso, id_modulo } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [formulario, setFormulario] = useState({});

  useEffect(() => {
    if (id_formulario > 0) {
      carregarFormulario(id_formulario);
      listarQuestoes(id_formulario);
    }
  }, [id_formulario]);

  // CARREGAR
  const carregarFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_formularios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setFormulario(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarQuestoes = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_questoes/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarQuestao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_questoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarQuestoes(id_formulario);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarQuestao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_questoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarQuestoes(id_formulario);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarQuestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_questoes/carregar/${id}`, []);

    if (api.statusCode === 200) {
      const response = api?.response?.data;

      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: response.descricao,
        ordem: response.ordem,
        peso: response.peso,
        status: response.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarQuestao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_questoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarQuestoes(id_formulario);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Ordem",
      dataIndex: "ordem",
      sorter: (a, b) => a.ordem?.toString()?.localeCompare(b.ordem?.toString()),
    },
    {
      title: "Peso",
      dataIndex: "peso",
      render: (_, e) => maskMoney(e?.peso ?? 0),
      sorter: (a, b) => maskMoney(a.peso ?? 0)?.localeCompare(maskMoney(b.peso ?? 0)),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Nº Alternativas",
      dataIndex: "total_alternativas",
      width: 150,
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Alternativas">
            <Button
              loading={loading}
              onClick={() =>
                navigate(
                  `/treinamentos/grupos/cursos/${id_grupo}/modulos/${id_curso}/formularios/${id_modulo}/questoes/${id_formulario}/alternativas/${e?.id}`
                )
              }
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>

          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarQuestao(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarQuestao(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_treinamentos_cad_formularios = id_formulario;

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarQuestao(formulario);
    } else {
      cadastrarQuestao(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()));
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalQuestao = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Questão
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="ordem" label="Ordem" rules={[{ required: true, message: "Informe a ordem!" }]}>
                <InputNumber
                  min={0}
                  size="large"
                  step={1}
                  max={999}
                  disabled={loading}
                  placeholder="Informe a ordem!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="peso" label="Peso" rules={[{ required: true, message: "Digite o peso!" }]}>
                <InputNumber
                  min={0}
                  size="large"
                  max={10000}
                  decimalSeparator=","
                  precision={2}
                  disabled={loading}
                  placeholder="Informe o peso!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalQuestao()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos"
              onClickBack={() =>
                navigate(`/treinamentos/grupos/cursos/${id_grupo}/modulos/${id_curso}/formularios/${id_modulo}`)
              }
            />
            <HeaderTitle
              title="Questões"
              subtitle={
                <Text italic>
                  <FileTextOutlined /> {formulario?.descricao ?? ""}
                </Text>
              }
              icon={<OrderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                rowClassName={(e, index) => (e?.total_alternativas === 0 ? "row-red" : "")}
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
